/* Mobile full-screen index menu, opened from the top bar's INDEX button.
   Lists the visible sections; tapping scrolls and closes. List comes from
   the editable section registry (passed from PublicSite). */
export function IndexMenu({ active, goTo, close, sections }) {
  return (
    <div className="index-overlay" role="dialog" aria-modal="true" aria-label="Section index">
      <div className="ohead">
        <div className="wordmark">
          Curated<b>H</b>omes
        </div>
        <button className="oclose" onClick={close} aria-label="Close index">
          &times;
        </button>
      </div>
      <ol>
        {sections.map((s) => (
          <li key={s.key}>
            <button className={active === s.key ? 'active' : ''} onClick={() => goTo(s.key)}>
              <span className="on">{s.num}</span>
              <span className="ot">{s.label}</span>
            </button>
          </li>
        ))}
      </ol>
    </div>
  )
}
